import { config, gameState } from '@js/state';

var selectedCount = 0;

var finalRouteMap = [];

var routeMapSet = 1;
var newPointDistanceTut = 0;

Array.prototype.insert = function (index, item) {
  this.splice(index, 0, item);
};

var plantArray = [[], [], [], [], []];

var plantLeftArray = [];

var array1_Tut = [];

var entrance = new Phaser.Geom.Point(0, 0);

var exitWay = new Phaser.Geom.Point(0, 0);

var tutP1 = new Phaser.Geom.Point(753, 154);
var tutP2 = new Phaser.Geom.Point(885, 154);
var tutP3 = new Phaser.Geom.Point(1018, 154);

var tutP4 = new Phaser.Geom.Point(753, 253);
var tutP5 = new Phaser.Geom.Point(885, 253);
var tutP6 = new Phaser.Geom.Point(1018, 253);

var tutP7 = new Phaser.Geom.Point(753, 352);
var tutP8 = new Phaser.Geom.Point(885, 352);
var tutP9 = new Phaser.Geom.Point(1018, 352);

var tutP10 = new Phaser.Geom.Point(753, 452);
var tutP11 = new Phaser.Geom.Point(885, 452);
var tutP12 = new Phaser.Geom.Point(1018, 452);

export default class TutorialScene extends Phaser.Scene {
  constructor() {
    super({
      key: "TutorialScene",
    });
  }

  preload() {
    this.load.image("tutBG", "assets/TutorialSceneAssets/tutBG.png");
    this.load.image("greyOverlay", "assets/TutorialSceneAssets/greyOverlay.png");

    this.load.image("tut_leftGarden", "assets/TutorialSceneAssets/tut_leftGarden.png");
    this.load.image("tut_rightGarden", "assets/TutorialSceneAssets/tut_rightGarden.png");

    this.load.image("plantLeftGarden", "assets/TutorialSceneAssets/plantLeftGarden.png");
    this.load.image("greyOverlayLeftGarden", "assets/TutorialSceneAssets/greyOverlayLeftGarden.png");

    this.load.image("tut_qn", "assets/TutorialSceneAssets/tut_qn.png");
    this.load.image("tut_ans", "assets/TutorialSceneAssets/tut_ans.png");

    this.load.image("tutText1", "assets/TutorialSceneAssets/tutText1.png");
    this.load.image("tutText2", "assets/TutorialSceneAssets/tutText2.png");
    this.load.image("tutText3", "assets/TutorialSceneAssets/tutText3.png");
    this.load.image("tutText4", "assets/TutorialSceneAssets/tutText4.png");

    this.load.image("whiteBoxTut", "assets/TutorialSceneAssets/whiteBoxTut.png");
   // this.load.multiatlas("endConfetti", "assets/EndSceneAssets/confetti/confettiAnimNew.json", "assets/EndSceneAssets/confetti");
  }

  create() {
    // config.audio.bgaudio.setVolume(0.005);

    config.audio.bgaudio = this.sound.add("bgaudio").setVolume(0.02);
    config.audio.bgaudio.play();

    // this.createPlants(tutP1, 0);

    // this.createLeftPlants();

    config.audio.correctAnswer = this.sound.add("correctAnswer").setVolume(0.05);

    config.audio.hover = this.sound.add("hover").setVolume(0.05);

    config.audio.waterCan = this.sound.add("waterCan").setVolume(0.05);
    config.audio.watering = this.sound.add("watering").setVolume(0.05);

    config.audio.sunShining = this.sound.add("sunShining").setVolume(0.05);
    config.audio.flowerBlossoming = this.sound.add("flowerBlossoming").setVolume(0.05);

    config.audio.ta1 = this.sound.add("ta1").setVolume(0.05);
    config.audio.ta2 = this.sound.add("ta2").setVolume(0.05);
    config.audio.ta3 = this.sound.add("ta3").setVolume(0.05);
    config.audio.ta4 = this.sound.add("ta4").setVolume(0.05);

    this.tutBG = this.add.sprite(config.width / 2, config.height / 2, "tutBG");

    this.correctGreen = this.add.sprite(510, 30, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);

    this.addWaterButton = this.add.sprite(859, 800, "addWaterButton").setOrigin(0).setDepth(0);

    this.tut_leftGarden = this.add.sprite(86, 120, "tut_leftGarden").setOrigin(0).setDepth(0);
    this.tut_rightGarden = this.add.sprite(720, 120, "tut_rightGarden").setOrigin(0).setDepth(0);

    this.plantLeftGarden = this.add.sprite(152, 166, "plantLeftGarden").setOrigin(0).setVisible(false);
    this.greyOverlayLeftGarden = this.add.sprite(121, 154, "greyOverlayLeftGarden").setOrigin(0).setVisible(false);

    this.tut_qn = this.add.sprite(20.14, 473.2, "tut_qn").setOrigin(0);
    this.tut_ans = this.add.sprite(653.14, 483.2, "tut_ans").setOrigin(0);

    this.greyOverlay = this.add.sprite(config.width / 2, config.height / 2, "greyOverlay").setDepth(1);

    this.tutText1 = this.add.sprite(439, 357, "tutText1").setOrigin(0).setVisible(false).setDepth(2);
    this.tutText2 = this.add.sprite(718, 352, "tutText2").setOrigin(0).setVisible(false).setDepth(2);
    this.tutText3 = this.add.sprite(44, 257, "tutText3").setOrigin(0).setVisible(false).setDepth(2);
    this.tutText4 = this.add.sprite(1076, 614, "tutText4").setOrigin(0).setVisible(false).setDepth(2);

    this.tut_input = this.add.text(715, 533, "0", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setDepth(6);

    this.can = this.physics.add.sprite(-200, 36.76, "wateringCanAnim").setVisible(false).setDepth(6).setOrigin(0.5, 0.65);

    this.hand = this.add.sprite(783, 179, "hand").setOrigin(0).setVisible(false).setDepth(6);

    this.hitBoxTut_1 = this.add.sprite(753, 154, "hitBoxTut").setOrigin(0).setAlpha(0.1).setDepth(4);
    this.hitBoxTut_2 = this.add.sprite(885, 154, "hitBoxTut").setOrigin(0).setAlpha(0.1).setDepth(4);
    this.hitBoxTut_3 = this.add.sprite(1018, 154, "hitBoxTut").setOrigin(0).setAlpha(0.1).setDepth(4);

    this.hitBoxTut_4 = this.add.sprite(753, 253, "hitBoxTut").setOrigin(0).setAlpha(0.1).setDepth(4);
    this.hitBoxTut_5 = this.add.sprite(885, 253, "hitBoxTut").setOrigin(0).setAlpha(0.1).setDepth(4);
    this.hitBoxTut_6 = this.add.sprite(1018, 253, "hitBoxTut").setOrigin(0).setAlpha(0.1).setDepth(4);

    this.hitBoxTut_7 = this.add.sprite(753, 352, "hitBoxTut").setOrigin(0).setAlpha(0.1).setDepth(4);
    this.hitBoxTut_8 = this.add.sprite(885, 352, "hitBoxTut").setOrigin(0).setAlpha(0.1).setDepth(4);
    this.hitBoxTut_9 = this.add.sprite(1018, 352, "hitBoxTut").setOrigin(0).setAlpha(0.1).setDepth(4);

    this.hitBoxTut_10 = this.add.sprite(753, 452, "hitBoxTut").setOrigin(0).setAlpha(0.1).setDepth(4);
    this.hitBoxTut_11 = this.add.sprite(885, 452, "hitBoxTut").setOrigin(0).setAlpha(0.1).setDepth(4);
    this.hitBoxTut_12 = this.add.sprite(1018, 452, "hitBoxTut").setOrigin(0).setAlpha(0.1).setDepth(4);

    this.whiteBox_1 = this.add.sprite(753, 154, "whiteBoxTut").setOrigin(0).setVisible(false).setDepth(4);
    this.whiteBox_2 = this.add.sprite(885, 154, "whiteBoxTut").setOrigin(0).setVisible(false).setDepth(4);
    this.whiteBox_3 = this.add.sprite(1017, 154, "whiteBoxTut").setOrigin(0).setVisible(false).setDepth(4);

    this.whiteBox_4 = this.add.sprite(753, 253, "whiteBoxTut").setOrigin(0).setVisible(false).setDepth(4);
    this.whiteBox_5 = this.add.sprite(885, 253, "whiteBoxTut").setOrigin(0).setVisible(false).setDepth(4);
    this.whiteBox_6 = this.add.sprite(1017, 253, "whiteBoxTut").setOrigin(0).setVisible(false).setDepth(4);

    this.whiteBox_7 = this.add.sprite(753, 352, "whiteBoxTut").setOrigin(0).setVisible(false).setDepth(4);
    this.whiteBox_8 = this.add.sprite(885, 352, "whiteBoxTut").setOrigin(0).setVisible(false).setDepth(4);
    this.whiteBox_9 = this.add.sprite(1017, 352, "whiteBoxTut").setOrigin(0).setVisible(false).setDepth(4);

    this.whiteBox_10 = this.add.sprite(753, 452, "whiteBoxTut").setOrigin(0).setVisible(false).setDepth(4);
    this.whiteBox_11 = this.add.sprite(885, 452, "whiteBoxTut").setOrigin(0).setVisible(false).setDepth(4);
    this.whiteBox_12 = this.add.sprite(1017, 452, "whiteBoxTut").setOrigin(0).setVisible(false).setDepth(4);

    this.anims.create({
      key: "floweringTut",
      frames: this.anims.generateFrameNames("flowering2Anim", {
        start: 30,
        end: 75,
        zeroPad: 0,
        prefix: "Flower",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.anims.create({
      key: "sunrise",
      frames: this.anims.generateFrameNames("sunAnim", {
        start: 0,
        end: 348,
        zeroPad: 0,
        prefix: "sunAnim",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.sun = this.add.sprite(0, 0, "sunAnim").setOrigin(0).setDepth(8);

    // .setInteractive({ cursor: "pointer" });

    // this.time.delayedCall(1000, () => { },[],this);

    // this.time.delayedCall(1000, () => {
    //   this.time.delayedCall(1000, () => {

    //     this.tutText1.setVisible(true);

    //   },[],this);
    // },[],this);

    this.showAndHide(this.tutText1, 1000, 2000);

    this.time.delayedCall(
      3000,
      () => {
        this.leftGardenPop();

        this.can.setVisible(true);

        // this.moveCanInitial(373,136.76,4.49,136.76);

        // this.moveCanInitial(433,136.76,104.49,136.76);

        this.moveCanInitial(433, 147.76, 104.49, 147.76);
      },
      [],
      this
    );
  }

  leftGardenPop() {
    this.tut_leftGarden.setDepth(3);
    this.tut_qn.setDepth(3);
    this.greyOverlayLeftGarden.setVisible(true).setDepth(3);
  }

  //   moveCanInitial(fromX, fromY, toX, toY){

  //     this.tweens.add({
  //       targets: this.can,
  //       duration: 3500,
  //       ease: 'Cubic',
  //       delay: 2000,
  //       yoyo: false,
  //       x: {from:fromX, to:toX},
  //       y: {from:fromY, to:toY},
  //       completeDelay:100,
  //       onComplete: ()=>{
  //         this.afterWateringLeftGarden();
  //       },
  //       onCompleteScope:this
  //   })

  // }

  //

  moveCanInitial(fromX, fromY, toX, toY) {
    this.time.delayedCall(
      2000,
      () => {
        this.can.setPosition(fromX, fromY);
      },
      [],
      this
    );

    this.time.delayedCall(
      3000,
      () => {
        this.waterThePlant(1500);

        // leafArray[startRouteCount-1].play("plantbudding").setVisible(true);
      },
      [],
      this
    );

    this.tweens.add({
      targets: this.can,
      duration: 2000,
      ease: "Linear",
      delay: 3000,
      yoyo: false,
      x: { from: fromX, to: toX },
      y: { from: fromY, to: toY },
      completeDelay: 2000,
      onComplete: () => {
        this.afterWateringLeftGarden();
      },
      onCompleteScope: this,
    });
  }

  //

  moveCan(fromX, fromY, toX, toY) {
    // this.getPositionCodeFromCoordinates(fromX,toX);

    // //>//>>>hidden_console.log(this.getPositionCodeFromCoordinates(fromX,fromY));

    // //>//>>>hidden_console.log(this.calculateDistance())

    this.time.delayedCall(
      1800,
      () => {
        this.waterThePlant(100);
        // leafArray[startRouteCount-1].play("plantbudding").setVisible(true);

        // this.createPlants(finalRouteMap[routeMapSet-1],routeMapSet-1);
      },
      [],
      this
    );

    this.time.delayedCall(
      1000,
      () => {
        this.createPlants(finalRouteMap[routeMapSet - 1], routeMapSet - 1);
      },
      [],
      this
    );

    this.tweens.add({
      targets: this.can,
      duration: 1500,
      ease: "Cubic",
      delay: 500,
      yoyo: false,
      x: { from: fromX, to: toX },
      y: { from: fromY, to: toY },
      completeDelay: 500,
      onComplete: () => {
        if (routeMapSet < finalRouteMap.length - 1) {
          this.moveCan(finalRouteMap[routeMapSet].x, finalRouteMap[routeMapSet].y, finalRouteMap[routeMapSet + 1].x, finalRouteMap[routeMapSet + 1].y);

          routeMapSet = routeMapSet + 1;
          //>//>>>hidden_console.log(routeMapSet);
        } else {
          config.audio.sunShining.play();

          this.tweens.add({
            targets: config.audio.sunShining,
            volume: 0.005,
            duration: 3000,
            onComplete: () => {},
          });

          this.greyOverlay.setVisible(false);

          this.sun.play("sunrise");

          this.time.delayedCall(
            3000,
            () => {
              this.buddingToFlowering();
              config.audio.sunShining.stop();
            },
            [],
            this
          );
        }
      },
      onCompleteScope: this,
    });
  }

  afterWateringLeftGarden() {
    this.can.setVisible(false);
    // this.plantLeftGarden.setVisible(true).setDepth(6);

    this.createLeftPlants();

    this.showAndHide(this.tutText2, 1000, 2000);

    this.time.delayedCall(
      4000,
      () => {
        this.rightGardenHighlight();
      },
      [],
      this
    );
  }

  rightGardenHighlight() {
    //>//>>>hidden_console.log("Right garden highlight");

    this.tut_leftGarden.setDepth(0);
    this.tut_qn.setDepth(0);

    this.tut_rightGarden.setDepth(3);
    this.tut_ans.setDepth(3);
    this.showAndHide(this.tutText3, 1000, 8000);

    this.tapHandAnimation(4000);
  }

  tapHandAnimation(delay) {
    this.time.delayedCall(
      delay,
      () => {
        this.hand.setVisible(true);
        this.startHandAnim();

        this.enableTilepad();
      },
      [],
      this
    );
  }

  enableTilepad() {
    this.hitBoxTut_1.setInteractive({ cursor: "pointer" });
    this.hitBoxTut_2.setInteractive({ cursor: "pointer" });
    this.hitBoxTut_3.setInteractive({ cursor: "pointer" });
    this.hitBoxTut_4.setInteractive({ cursor: "pointer" });
    this.hitBoxTut_5.setInteractive({ cursor: "pointer" });
    this.hitBoxTut_6.setInteractive({ cursor: "pointer" });
    this.hitBoxTut_7.setInteractive({ cursor: "pointer" });
    this.hitBoxTut_8.setInteractive({ cursor: "pointer" });
    this.hitBoxTut_9.setInteractive({ cursor: "pointer" });
    this.hitBoxTut_10.setInteractive({ cursor: "pointer" });
    this.hitBoxTut_11.setInteractive({ cursor: "pointer" });
    this.hitBoxTut_12.setInteractive({ cursor: "pointer" });

    this.hitboxClickAndHoverHandle();
  }

  disableTilepadAndGoForward() {
    this.hitBoxTut_1.removeInteractive();
    this.hitBoxTut_2.removeInteractive();
    this.hitBoxTut_3.removeInteractive();
    this.hitBoxTut_4.removeInteractive();
    this.hitBoxTut_5.removeInteractive();
    this.hitBoxTut_6.removeInteractive();
    this.hitBoxTut_7.removeInteractive();
    this.hitBoxTut_8.removeInteractive();
    this.hitBoxTut_9.removeInteractive();
    this.hitBoxTut_10.removeInteractive();
    this.hitBoxTut_11.removeInteractive();
    this.hitBoxTut_12.removeInteractive();

    this.removeWhiteBox();

    this.addWaterButton.setDepth(4).setInteractive({ cursor: "pointer" });

    this.can.setPosition(-200, -200);

    this.slideInAddwaterButton();

    this.handleAddWaterButton();
  }

  slideInAddwaterButton() {
    this.tweens.add({
      targets: this.addWaterButton,
      duration: 500,
      ease: "easeInOutSine",
      //delay: 100,
      yoyo: false,
      // x: {from:783, to:1069},
      y: { from: 800, to: 633 },
      // scale: {from:1, to:0.8},
      loop: 0,
      completeDelay: 200,
      onComplete: () => {
        this.tutText4.setVisible(true);
        config.audio.ta4.play();
      },
    });
  }

  pathFinding() {
    finalRouteMap.push(array1_Tut[0]);

    array1_Tut.splice(0, 1);

    ////>//>>>hidden_console.log(array1_Tut)

    for (let i = 0; i < finalRouteMap.length; i++) {
      var distanceArray = [];
      for (let j = 0; j < array1_Tut.length; j++) {
        // var dist = Math.sqrt(Math.pow(finalRouteMap[i][0] - array1_Tut[j][0], 2) + Math.pow(finalRouteMap[i][1] - array1_Tut[j][1], 2));
        var dist = Phaser.Math.Distance.BetweenPoints(finalRouteMap[i], array1_Tut[j]);
        distanceArray.push(dist);
      }
      var index = distanceArray.indexOf(Math.min(...distanceArray));

      finalRouteMap.push(array1_Tut[index]);
      array1_Tut.splice(index, 1);
      //>//>>>hidden_console.log(finalRouteMap);

      if (finalRouteMap.length == 3) {
        break;
      }
    }
  }

  handleAddWaterButton() {
    this.addWaterButton.on("pointerover", () => {
      this.addWaterButton.setTexture("hover_addWaterButton");
    });
    this.addWaterButton.on("pointerout", () => {
      this.addWaterButton.setTexture("addWaterButton");
    });
    this.addWaterButton.on("pointerup", () => {
      // this.moveCan(routeMap[0][0],routeMap[0][1],routeMap[1][0],routeMap[1][1]);

      this.tutText4.setVisible(false);
      this.addWaterButton.setVisible(false);

      if (selectedCount == 3) {
        config.audio.correctAnswer.play();

        this.pathFinding();

        // this.Q5_ans.setTint(0xffffff);

        this.correctGreen.setVisible(true);

        if (finalRouteMap[0] == tutP1) {
          entrance.setTo(753, -200);
        } else if (finalRouteMap[0] == tutP2) {
          entrance.setTo(885, -200);
        } else if (finalRouteMap[0] == tutP3) {
          entrance.setTo(2078, 154);
        } else if (finalRouteMap[0] == tutP4) {
          entrance.setTo(753, -200);
        } else if (finalRouteMap[0] == tutP5) {
          entrance.setTo(885, -200);
        } else if (finalRouteMap[0] == tutP6) {
          entrance.setTo(2078, 253);
        } else if (finalRouteMap[0] == tutP7) {
          entrance.setTo(753, 900);
        } else if (finalRouteMap[0] == tutP8) {
          entrance.setTo(885, 900);
        } else if (finalRouteMap[0] == tutP9) {
          entrance.setTo(2078, 352);
        } else if (finalRouteMap[0] == tutP10) {
          entrance.setTo(753, 900);
        } else if (finalRouteMap[0] == tutP11) {
          entrance.setTo(885, 900);
        } else if (finalRouteMap[0] == tutP12) {
          entrance.setTo(2078, 452);
        }

        finalRouteMap.unshift(entrance);

        if (finalRouteMap[finalRouteMap.length - 1] == tutP1) {
          exitWay.setTo(753, -200);
        } else if (finalRouteMap[finalRouteMap.length - 1] == tutP2) {
          exitWay.setTo(844, -200);
        } else if (finalRouteMap[finalRouteMap.length - 1] == tutP3) {
          exitWay.setTo(2078, 154);
        } else if (finalRouteMap[finalRouteMap.length - 1] == tutP4) {
          exitWay.setTo(753, -200);
        } else if (finalRouteMap[finalRouteMap.length - 1] == tutP5) {
          exitWay.setTo(727, -200);
        } else if (finalRouteMap[finalRouteMap.length - 1] == tutP6) {
          exitWay.setTo(2078, 253);
        } else if (finalRouteMap[finalRouteMap.length - 1] == tutP7) {
          exitWay.setTo(753, 900);
        } else if (finalRouteMap[finalRouteMap.length - 1] == tutP8) {
          exitWay.setTo(885, 900);
        } else if (finalRouteMap[finalRouteMap.length - 1] == tutP9) {
          exitWay.setTo(2078, 352);
        } else if (finalRouteMap[finalRouteMap.length - 1] == tutP10) {
          exitWay.setTo(753, 900);
        } else if (finalRouteMap[finalRouteMap.length - 1] == tutP11) {
          exitWay.setTo(885, 900);
        } else if (finalRouteMap[finalRouteMap.length - 1] == tutP12) {
          exitWay.setTo(2078, 452);
        }

        finalRouteMap.push(exitWay);

        this.can.setVisible(true);

        this.moveCan(finalRouteMap[0].x, finalRouteMap[0].y, finalRouteMap[1].x, finalRouteMap[1].y);
      } else {
        // this.Q5_ans.setTint(0xFFC2A2);
      }
    });
  }

  createPlants(selectedPoint, plantSelectionCode) {
    plantArray[plantSelectionCode][0] = this.add
      .sprite(selectedPoint.x + 25, selectedPoint.y + 20, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);
    plantArray[plantSelectionCode][1] = this.add
      .sprite(selectedPoint.x + 75, selectedPoint.y + 20, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);

    plantArray[plantSelectionCode][2] = this.add
      .sprite(selectedPoint.x + 65, selectedPoint.y + 50, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);
    plantArray[plantSelectionCode][3] = this.add
      .sprite(selectedPoint.x + 115, selectedPoint.y + 50, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);
  }

  createLeftPlants() {
    var leftPlantOrigin = new Phaser.Geom.Point(179, 169);

    var xshift = 0;
    var yshift = 0;

    for (var j = 0; j < 6; j++) {
      plantLeftArray[j] = this.add
        .sprite(leftPlantOrigin.x + xshift, leftPlantOrigin.y + yshift, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);

      xshift += 60;
    }

    xshift = -25;
    yshift = 30;

    for (var j = 0; j < 6; j++) {
      plantLeftArray[j + 6] = this.add
        .sprite(leftPlantOrigin.x + xshift, leftPlantOrigin.y + yshift, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);

      xshift += 60;
    }
  }

  buddingToFlowering() {
    config.audio.flowerBlossoming.play();

    this.greyOverlay.setVisible(false);

    for (var j = 0; j <= 11; j++) {
      plantLeftArray[j].setTexture("flowering2Anim").play("floweringTut");

      // = this.add.sprite(leftPlantOrigin.x + xshift,leftPlantOrigin.y + yshift,"playSwayAnim").setScale(0.3).play("plantbudding").setDepth(5);
    }

    for (var k = 0; k < plantArray.length; k++) {
      for (var l = 0; l < plantArray[k].length; l++) {
        plantArray[l][k].setTexture("flowering2Anim").play("floweringTut");
      }
    }

    this.tweens.add({
      targets: config.audio.bgaudio,
      volume: 0.005,
      duration: 5000,
      onComplete: () => {},
    });

    this.time.delayedCall(
      4000,
      () => {
        this.cameras.main.fadeOut(1000, 255, 255, 255);

        this.cameras.main.once(
          "camerafadeoutcomplete",
          function (camera) {
            config.audio.bgaudio.stop();
            config.audio.flowerBlossoming.stop();
            config.audio.sunShining.stop();

            this.wipeSceneTut();

            this.scene.stop("TutorialScene");

            // this.scene.start("TutorialScene");

            this.scene.start("GameSceneQ2");
          },
          this
        );
      },
      [],
      this
    );
  }

  wipeSceneTut() {
    selectedCount = 0;

    finalRouteMap = [];

    routeMapSet = 1;

    plantArray = [[], [], [], [], []];

    plantLeftArray = [];

    array1_Tut = [];
  }

  showAndHide(thing, showdelay, sustain, callback) {
    this.time.delayedCall(
      showdelay,
      () => {
        if (thing == this.tutText1) {
          config.audio.ta1.play();
        } else if (thing == this.tutText2) {
          config.audio.ta2.play();
        } else if (thing == this.tutText3) {
          config.audio.ta3.play();
        }

        thing.setVisible(true);

        this.time.delayedCall(
          sustain,
          () => {
            thing.setVisible(false);

            if (callback && typeof callback == "function") {
              callback();
              //>//>>>hidden_console.log("function detected")
            }
          },
          [],
          this
        );
      },
      [],
      this
    );
  }

  hitboxClickAndHoverHandle() {
    this.hitBoxTut_1.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxTut_1, 0, 0);
      },
      this
    );
    this.hitBoxTut_2.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxTut_2, 1, 0);
      },
      this
    );
    this.hitBoxTut_3.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxTut_3, 2, 0);
      },
      this
    );

    this.hitBoxTut_4.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxTut_4, 0, 1);
      },
      this
    );
    this.hitBoxTut_5.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxTut_5, 1, 1);
      },
      this
    );
    this.hitBoxTut_6.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxTut_6, 2, 1);
      },
      this
    );

    this.hitBoxTut_7.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxTut_7, 0, 2);
      },
      this
    );
    this.hitBoxTut_8.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxTut_8, 1, 2);
      },
      this
    );
    this.hitBoxTut_9.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxTut_9, 2, 2);
      },
      this
    );

    this.hitBoxTut_10.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxTut_10, 0, 3);
      },
      this
    );
    this.hitBoxTut_11.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxTut_11, 1, 3);
      },
      this
    );
    this.hitBoxTut_12.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxTut_12, 2, 3);
      },
      this
    );

    this.hitBoxTut_1.on(
      "pointerover",
      () => {
        this.showWhiteBox(1);
      },
      this
    );
    this.hitBoxTut_2.on(
      "pointerover",
      () => {
        this.showWhiteBox(2);
      },
      this
    );
    this.hitBoxTut_3.on(
      "pointerover",
      () => {
        this.showWhiteBox(3);
      },
      this
    );
    this.hitBoxTut_4.on(
      "pointerover",
      () => {
        this.showWhiteBox(4);
      },
      this
    );
    this.hitBoxTut_5.on(
      "pointerover",
      () => {
        this.showWhiteBox(5);
      },
      this
    );
    this.hitBoxTut_6.on(
      "pointerover",
      () => {
        this.showWhiteBox(6);
      },
      this
    );
    this.hitBoxTut_7.on(
      "pointerover",
      () => {
        this.showWhiteBox(7);
      },
      this
    );
    this.hitBoxTut_8.on(
      "pointerover",
      () => {
        this.showWhiteBox(8);
      },
      this
    );
    this.hitBoxTut_9.on(
      "pointerover",
      () => {
        this.showWhiteBox(9);
      },
      this
    );
    this.hitBoxTut_10.on(
      "pointerover",
      () => {
        this.showWhiteBox(10);
      },
      this
    );
    this.hitBoxTut_11.on(
      "pointerover",
      () => {
        this.showWhiteBox(11);
      },
      this
    );
    this.hitBoxTut_12.on(
      "pointerover",
      () => {
        this.showWhiteBox(12);
      },
      this
    );

    this.hitBoxTut_1.on(
      "pointerout",
      () => {
        this.removeWhiteBox();
      },
      this
    );
    this.hitBoxTut_2.on(
      "pointerout",
      () => {
        this.removeWhiteBox();
      },
      this
    );
    this.hitBoxTut_3.on(
      "pointerout",
      () => {
        this.removeWhiteBox();
      },
      this
    );
    this.hitBoxTut_4.on(
      "pointerout",
      () => {
        this.removeWhiteBox();
      },
      this
    );
    this.hitBoxTut_5.on(
      "pointerout",
      () => {
        this.removeWhiteBox();
      },
      this
    );
    this.hitBoxTut_6.on(
      "pointerout",
      () => {
        this.removeWhiteBox();
      },
      this
    );
    this.hitBoxTut_7.on(
      "pointerout",
      () => {
        this.removeWhiteBox();
      },
      this
    );
    this.hitBoxTut_8.on(
      "pointerout",
      () => {
        this.removeWhiteBox();
      },
      this
    );
    this.hitBoxTut_9.on(
      "pointerout",
      () => {
        this.removeWhiteBox();
      },
      this
    );
    this.hitBoxTut_10.on(
      "pointerout",
      () => {
        this.removeWhiteBox();
      },
      this
    );
    this.hitBoxTut_11.on(
      "pointerout",
      () => {
        this.removeWhiteBox();
      },
      this
    );
    this.hitBoxTut_12.on(
      "pointerout",
      () => {
        this.removeWhiteBox();
      },
      this
    );
  }

  startHandAnim() {
    this.tweens.add({
      targets: this.hand,
      duration: 500,
      ease: "easeInOutSine",
      // delay: 500,
      yoyo: true,
      // x: {from:783, to:1069},
      // y: {from:179, to:640},
      scale: { from: 1, to: 0.8 },
      loop: -1,
    });

    // this.tweens.add({
    //   targets: this.hand,
    //   duration: 1500,
    //   ease: 'easeInOutSine',
    //   loopDelay: 500,
    //   yoyo: true,
    //   x: {from:783, to:1069},
    //   // y: {from:179, to:640},
    //   // scale: {from:1, to:0.8},
    //   loop:-1,
    //   });
  }

  toggleHit(hitboxname, xcode, ycode) {
    //>//>>>hidden_console.log("xcode: " + xcode + " ycode: " + ycode);

    this.hand.setVisible(false);

    if (hitboxname.alpha == 0.1) {
      hitboxname.setAlpha(1);

      this.updateRouteMap(xcode, ycode);

      selectedCount += 1;

      this.tut_input.setText(selectedCount);

      // if(selectedCount >= 3){
      //   this.disableTilepadAndGoForward();
      // }
    } else {
      hitboxname.setAlpha(0.1);

      // this.updateRouteMap(xcode,ycode);

      Phaser.Utils.Array.Remove(array1_Tut, this.getPointFromCode(xcode, ycode));

      selectedCount -= 1;

      // if(selectedCount >= 3){
      //   this.disableTilepadAndGoForward();
      // }

      this.tut_input.setText(selectedCount);
    }

    if (selectedCount >= 3) {
      this.disableTilepadAndGoForward();
    }
  }

  updateRouteMap(xcode, ycode) {
    array1_Tut.push(this.getPointFromCode(xcode, ycode));
  }

  getPointFromCode(xcode, ycode) {
    if (xcode == 0 && ycode == 0) {
      return tutP1;
    } else if (xcode == 1 && ycode == 0) {
      return tutP2;
    } else if (xcode == 2 && ycode == 0) {
      return tutP3;
    } else if (xcode == 0 && ycode == 1) {
      return tutP4;
    } else if (xcode == 1 && ycode == 1) {
      return tutP5;
    } else if (xcode == 2 && ycode == 1) {
      return tutP6;
    } else if (xcode == 0 && ycode == 2) {
      return tutP7;
    } else if (xcode == 1 && ycode == 2) {
      return tutP8;
    } else if (xcode == 2 && ycode == 2) {
      return tutP9;
    } else if (xcode == 0 && ycode == 3) {
      return tutP10;
    } else if (xcode == 1 && ycode == 3) {
      return tutP11;
    } else if (xcode == 2 && ycode == 3) {
      return tutP12;
    }
  }

  calculateDistance(target1, target2) {
    return Phaser.Math.Distance.BetweenPoints(target1, target2);
  }

  showWhiteBox(position) {
    config.audio.hover.play();

    this.removeWhiteBox();
    if (position == 1) {
      this.whiteBox_1.setVisible(true);
    }
    if (position == 2) {
      this.whiteBox_2.setVisible(true);
    }
    if (position == 3) {
      this.whiteBox_3.setVisible(true);
    }
    if (position == 4) {
      this.whiteBox_4.setVisible(true);
    }
    if (position == 5) {
      this.whiteBox_5.setVisible(true);
    }
    if (position == 6) {
      this.whiteBox_6.setVisible(true);
    }
    if (position == 7) {
      this.whiteBox_7.setVisible(true);
    }
    if (position == 8) {
      this.whiteBox_8.setVisible(true);
    }
    if (position == 9) {
      this.whiteBox_9.setVisible(true);
    }
    if (position == 10) {
      this.whiteBox_10.setVisible(true);
    }
    if (position == 11) {
      this.whiteBox_11.setVisible(true);
    }
    if (position == 12) {
      this.whiteBox_12.setVisible(true);
    }
  }

  removeWhiteBox() {
    this.whiteBox_1.setVisible(false);
    this.whiteBox_2.setVisible(false);
    this.whiteBox_3.setVisible(false);
    this.whiteBox_4.setVisible(false);
    this.whiteBox_5.setVisible(false);
    this.whiteBox_6.setVisible(false);
    this.whiteBox_7.setVisible(false);
    this.whiteBox_8.setVisible(false);
    this.whiteBox_9.setVisible(false);
    this.whiteBox_10.setVisible(false);
    this.whiteBox_11.setVisible(false);
    this.whiteBox_12.setVisible(false);
  }

  waterThePlant(flowingtime) {
    if (routeMapSet <= selectedCount || selectedCount == 0) {
      config.audio.watering.play();
    }

    this.can.play("startwatering");

    this.time.delayedCall(
      1000,
      () => {
        this.can.play("waterflowing");

        this.time.delayedCall(
          flowingtime,
          () => {
            this.can.play("stopwatering");

            config.audio.watering.stop();
          },
          [],
          this
        );
      },
      [],
      this
    );
  }

  update() {}
}
